// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    qa: false,
    dev: false,
    isDebugMode: false
};

let PROVIDERS: any[] = [
    /**
     * Common env directives
     */
];

PROVIDERS = [
    ...PROVIDERS,
    { provide: 'AUTH_URL', useValue: 'https://gateway.phoenix-apothekenportal.de' },
    { provide: 'API_URL', useValue: 'https://gateway.phoenix-apothekenportal.de' },
   // { provide: 'CMS_URL', useValue: 'https://phoenix-web-dev.twt-dh.de' },
    { provide: 'CMS_URL', useValue: 'https://cms.phoenix-apothekenportal.de'},
    { provide: 'ADMIN_MAIL', useValue: 'apothekenportal@phoenixgroup.eu' },
    { provide: 'REQ_DATE_FORMAT', useValue: 'yyyy-MM-dd' },
    { provide: 'VIEW_DATE_FORMAT', useValue: 'yyyy-MM-dd' },
    // deine Apotheke-Store providers
    { provide: 'DA_STORE_URL', useValue: 'https://phoenix-store.net/apologin'},
    { provide: 'DA_STORE_REFERRER', useValue: 'apothekenportal'},
    // Privatsortiment (Genuss Kultur) providers
    { provide: 'PS_URL', useValue: 'https://privatsortiment.de/apologin'},
    { provide: 'PS_REFERRER', useValue: 'apothekenportal'},
    // Notfalldepot providers
    {provide: 'ND_URL', useValue: 'https://deineapotheke-store.de/apologin'},
    {provide: 'ND_REFERRER', useValue: 'apothekenportal'},
    {provide: 'ND_FLAG', useValue: 'notfalldepot'},
    {provide: 'STORAGE', useValue: 'https://cspappsacc.blob.core.windows.net'},
    {provide: 'CDN', useValue: 'https://cspappsacc.blob.core.windows.net'},
    {provide: 'DATEV_REDIRECT', useValue: 'https://phoenix-apothekenportal.de/datev'},
    {provide: 'DATEV_LINK', useValue: 'https://login.datev.de/openid'}


    /**
     * Custom providers in development.
     */
];

export const ENV_PROVIDERS = [
    ...PROVIDERS
];
